import { ChangeDetectionStrategy, Component } from '@angular/core'
import { Router } from '@angular/router'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { GbAuthDialogViewService } from '../gb-auth-dialog-view-service/gb-auth-dialog-view.service'
import { AuthConstants } from 'libs/gb-front/auth/feature/login/src/lib/gb-front-auth-feature-login-routing.module'
import { GbFrontDialogService } from 'libs/gb-front/shared/util/src/lib/gb-front-dialog-service/gb-front-dialog.service'
import { GbPrivacyPolicyDialogComponent } from 'libs/gb-front/account/ui/src/lib/gb-privacy-policy-dialog/gb-privacy-policy-dialog.component'

@Component({
  selector: 'gb-auth-dialog-login',
  templateUrl: './gb-auth-dialog-login.component.html',
  styleUrls: ['./gb-auth-dialog-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbAuthDialogLoginComponent {
  urlName$ = this.auctionFacade.auctionUrlName$
  displaySocialLogin$ = this.auctionFacade.displaySocialLogin$

  constructor(
    private auctionFacade: AuctionFacade,
    private gbAuthDialogViewService: GbAuthDialogViewService,
    private gbFrontDialogService: GbFrontDialogService,
    private router: Router,
  ) {}

  openPrivacyPolicy(): void {
    this.gbFrontDialogService.openDialog(GbPrivacyPolicyDialogComponent)
  }

  goToRegister(): void {
    this.gbAuthDialogViewService.goToRegister()
  }

  goToForgotPassword(urlName: string): void {
    this.router.navigate([urlName, AuthConstants.FORGOT_PASSWORD])
  }
}
